import React from 'react'


const Contact = () => {
  return (
    <div>
  
      <h1>Welcome to the Contact Page</h1>
    </div>
  )
}

export default Contact
